import Vue from 'vue'
import App from './views/App.vue'
import router from './router'
import store from './store'
import { Helpers } from './mixins'
import './filters'
import Page from './layouts/Page.vue'
import Blank from './layouts/Blank.vue'
Vue.component('page-layout', Page)
Vue.component('blank-layout', Blank)

import vuetify from './plugins/vuetify'
import './assets/styles/app.scss'
import { prefetchCoverage } from './utils/coverage'

let host = window.location.hostname
let port = host == 'localhost' ? 8000 : null
let protocol = window.location.protocol

let SOCKET = port == null ? `${protocol == 'http:' ? 'ws:' : 'wss:'}//${host}` : `${protocol == 'http:' ? 'ws:' : 'wss:'}//${host}:${port}`

// 
// Connect to SOCKET server 
// 
import VueNativeSock from 'vue-native-websocket'

// WebSocket connection setup function
let socketInstance = null

function setupWebSocket() {
  const user = store.state.user
  if (user && user.username && !socketInstance) {
    // Debug: Log the WebSocket URL being used
    const wsUrl = `${SOCKET}/notify/${user.username}/`
    
    // Create WebSocket configuration
    const socketConfig = {
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 3000,
      store: store,
      format: 'json',
      connectManually: false,
      heartbeat: {
        message: 'ping',
        interval: 60000,
        pongTimeout: 15000
      }
    }
    
    try {
      Vue.use(VueNativeSock, wsUrl, socketConfig)
      socketInstance = true
      store.commit('connectSocket')
    } catch (error) {
      socketInstance = null
    }
  }
}

function disconnectWebSocket() {
  if (socketInstance) {
    store.commit('disconnectSocket')
    if (Vue.prototype.$socket) {
      Vue.prototype.$socket.close()
    }
    socketInstance = null
  }
}

// Initial WebSocket setup if user is already logged in
if (store.state.user && store.state.access) {
  setupWebSocket()
}

// Watch for user changes to establish WebSocket connection
store.subscribe((mutation, state) => {
  if (mutation.type === 'setUser' && state.user && state.access) {
    // User just logged in, setup WebSocket
    setTimeout(() => {
      setupWebSocket()
    }, 1000)
    prefetchCoverage()
  } else if (mutation.type === 'authLogout') {
    // User logged out, disconnect WebSocket
    disconnectWebSocket()
  }
})
// 
Vue.mixin(Helpers)
// 
// Check if used is logged in before each request
// 
router.beforeEach((to, from, next) => {
  if (to.name !== 'login') {
    if (store.state.access === null) {
      next({ name: 'login' })
    } else {
      next(!!store.state.user)
      return
    }
  } else {
    next()
  }
})

// Vue Process
new Vue({ router, store, vuetify, render: h => h(App) }).$mount('#app')

// Warm the coverage map cache once the app is idle, so Forecasting opens with it ready
if (store.state.access) {
  prefetchCoverage()
}
